<template>
  <RegionalBenefit>
    {{ i18n(translations.title) }}
    <template #appendix>
      <div class="space-y-24">
        <div class="space-y-24">
          <h4>{{ i18n(translations.europeTitle) }}</h4>
          {{ i18n(translations.europeBody) }}
        </div>

        <div class="space-y-24">
          <h4>{{ i18n(translations.africaTitle) }}</h4>
          {{ i18n(translations.africaBody) }}
        </div>

        <div class="space-y-24">
          <h4>{{ i18n(translations.asiaOceaniaTitle) }}</h4>
          {{ i18n(translations.asiaOceaniaBody) }}
        </div>

        <div class="space-y-24">
          <h4>{{ i18n(translations.americaTitle) }}</h4>
          {{ i18n(translations.americaBody) }}
        </div>
      </div>
    </template>
  </RegionalBenefit>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import RegionalBenefit from '../RegionalBenefit/RegionalBenefit.vue'

import translations from './CallsAndSmsUnlimitedTowardsEurope120Contries.translations'

const i18n = useI18n()
</script>
